import { render, staticRenderFns } from "./OAClientNewPage.vue?vue&type=template&id=7335d40d"
import script from "./OAClientNewPage.vue?vue&type=script&lang=ts"
export * from "./OAClientNewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports